import toast from './toast'
import svgInline from './svgInline'
import vueQuery from './vueQuery'
import floatingVue from './floatingVue'

export default [toast, svgInline, vueQuery, floatingVue]